module.exports = __webpack_public_path__ + "img/person_outline-24px.6f30ca93.svg";